import { Evented } from '@dojo/framework/core/Evented';
import { logSystem } from 'logger';
import BrowserWebSocket from './getWS';
export var ReadyState;
(function (ReadyState) {
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})(ReadyState || (ReadyState = {}));
export var SendState;
(function (SendState) {
    SendState[SendState["OKAY"] = 0] = "OKAY";
    SendState[SendState["NOT_READY"] = 1] = "NOT_READY";
    SendState[SendState["BUFFERING"] = 2] = "BUFFERING";
    SendState[SendState["SEND_ERROR"] = 3] = "SEND_ERROR";
})(SendState || (SendState = {}));
export class WSocket extends Evented {
    constructor(url, options = {}) {
        super();
        this._state = ReadyState.CLOSED;
        this._url = url;
        this._socket = null;
    }
    get state() {
        return this._state;
    }
    get url() {
        return this._url;
    }
    get msgcache() {
        return this._msgcache;
    }
    get socket() {
        return this._socket;
    }
    handleClose(event) {
        logSystem.info({ msg: 'WS CloseEvent', data: event });
        this._state = ReadyState.CLOSED;
        const socket = this._socket;
        if (socket && socket.readyState < BrowserWebSocket.CLOSING) {
            socket.onclose = null;
            socket.onerror = null;
            socket.onmessage = null;
            socket.close();
        }
        this.emit({ type: 'close', event });
        this._socket = null;
    }
    open(force) {
        if (this._socket) {
            if (!force) {
                return;
            }
            const socket = this._socket;
            socket.onclose = null;
            socket.onerror = null;
            socket.onmessage = null;
            if (socket.readyState < BrowserWebSocket.CLOSING) {
                socket.close();
            }
            this._socket = null;
        }
        this._state = ReadyState.CONNECTING;
        const socket = (this._socket = new BrowserWebSocket(this._url));
        socket.onerror = this.handleClose.bind(this);
        logSystem.debug({ msg: 'opening', data: socket });
        socket.onopen = (event) => {
            this._state = ReadyState.OPEN;
            this.emit({ type: 'open', event });
            socket.onmessage = (event) => {
                this.emit({ type: 'message', data: event.data });
            };
            socket.onerror = (event) => {
                this.emit({ type: 'error', event });
                this.handleClose({});
            };
            socket.onclose = this.handleClose.bind(this);
        };
    }
    close(...args) {
        this._state = ReadyState.CLOSING;
        if (this._socket) {
            this._socket.close(...args);
        }
    }
    send(message) {
        const socket = this._socket;
        let success = SendState.OKAY;
        if (!this.is_open()) {
            return SendState.NOT_READY;
        }
        if (socket === null) {
            return SendState.NOT_READY;
        }
        if (socket.readyState !== BrowserWebSocket.OPEN) {
            this.handleClose({ reason: '[Internal] WS readyState not OPEN' });
            return SendState.NOT_READY;
        }
        if (socket.bufferedAmount > 0) {
            return SendState.BUFFERING;
        }
        this._msgcache = message;
        try {
            socket.send(message);
            success = SendState.OKAY;
        }
        catch (e) {
            this.handleClose({ reason: '[Internal] Failed to send message' });
            success = SendState.SEND_ERROR;
        }
        return success;
    }
    is_open() {
        return !!this._socket && this._state === ReadyState.OPEN && this._socket.readyState === BrowserWebSocket.OPEN;
    }
}
export default WSocket;
